import dayjs, { Dayjs } from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

import 'dayjs/locale/pl';

export enum DateFormat {
  Relative,
  DateMedium = 'D-MMM-YYYY',
  DatePicker = 'DD-MM-YYYY',
  DateFull = 'D MMMM YYYY',
  DateWithTime = 'D-MMM-YYYY, HH:mm',
  DateFullWithTime = 'D MMMM YYYY, HH:mm',
  DateFullWithTimeAndZone = 'D MMMM YYYY, HH:mm z',
  DateFullWithZone = 'D MMMM YYYY z',
  DateWithFullTime = 'D-MMM-YYYY | HH:mm:ss',
  MaintenanceTime = 'dddd [the] Do [of] MMMM [at] HH:mm z',
}

dayjs.extend(relativeTime);
dayjs.extend(advancedFormat);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.guess();

const theEndOfTheWorldInSeconds = new Date('3023-10-20T00:00:00.000Z').valueOf() / 1000;

export const getDateObject = (date: string | number | Dayjs) => {
  if (typeof date === 'object') return date;
  // detect seconds / milliseconds
  if (typeof date === 'number' && date < theEndOfTheWorldInSeconds) date *= 1000;
  return dayjs(date);
};

export const dateFormat = (date: string | number | Dayjs, format: DateFormat, language: string): string => {
  const dateObject = getDateObject(date);

  if (format === DateFormat.Relative) {
    return dateObject.locale(language).fromNow();
  }
  return dateObject.locale(language).format(format);
};
